import React, { useState, useEffect } from "react";

import "./LandlordPaymentView.css";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";

import { useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import axios from "axios";
import { toast } from "react-toastify";
import Loading from "../../components/Loading/Loading";

const LandlordPaymentView = () => {
  const { accessToken } = useAuth();
  const location = useLocation();
  // console.log("location: ", location);

  const { listingId } = location.state || {};
  console.log("--- listingId: ", listingId);
  // const listingId = "60";

  // console.log(import.meta.env.VITE_TEST);
  // console.log("stripe key", import.meta.env.STRIPE_KEY);

  const [isLoading, setIsLoading] = useState(true);

  const showErrorMessage = (text) => {
    // toast("Check!");
    toast.error(text, {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      // draggable: true,
      progress: undefined,
      theme: "colored",
      // transition: Bounce,
    });
  };

  useEffect(() => {
    const startPaymentsSession = async () => {
      try {
        const requestData = {
          listingId: listingId,
        };

        // console.log("req data: ", requestData);

        // console.log("accessToken - first: ", accessToken);
        const response = await axios.post(
          `${
            import.meta.env.VITE_BACKEND_URL
          }/payment/create-premium-checkout-session`,
          requestData,
          {
            headers: { Authorization: accessToken },
          }
        );

        // console.log("response: ", response);

        if (response.status === 200) {
          if (
            response.data &&
            "success" in response.data &&
            response.data.success
          ) {
            // Fetching user successful
            // console.log("Addition successful");
            // console.log("response: ", response);
            // console.log("test: ", response.data);
            if ("paymentUrl" in response.data && response.data.paymentUrl) {
              // redirect
              // alert(response.data.paymentUrl);
              window.location.href = response.data.paymentUrl;
            } else {
              // show error
              showErrorMessage(
                "Unable to redirect to payments page. Please try again!"
              );
            }
          } else {
            // Handle authentication error (e.g., display an error message)
            var errorMsg =
              response.data && response.data.message
                ? response.data.message
                : "Some error occurred while starting the payment session. Please try again!";
            var responseError =
              response.data && response.data.error
                ? response.data.error
                : response.status + " error";
            // console.log(responseError);

            // required message to the user will be shown here
            showErrorMessage(errorMsg);
          }
        } else {
          // Handle authentication error (e.g., display an error message)
          var errorMsg =
            response.data && response.data.message
              ? response.data.message
              : "Some error starting the payment session. Please try again!";
          showErrorMessage(errorMsg);
          var responseError =
            response.data && response.data.error
              ? response.data.error
              : response.status + " error";
          // console.log(responseError);
          // You can display an error message to the user.
        }
      } catch (error) {
        console.error("Error during validation:", error);
      }
    };
    

    if (listingId && accessToken) {
      // console.log("listingId: ", listingId);
      // console.log("accessToken: ", accessToken);
      // alert("start?");
      startPaymentsSession();

      setIsLoading(true);
    }
  }, [listingId, accessToken]);

  return (
    <div>
      <Navbar />
      <div className="container">
        {isLoading ? (
          <Loading />
        ) : listingId ? (
          <div>Redirecting to payment...</div>
        ) : (
          <div>Unauthorized access</div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default LandlordPaymentView;
